var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "136 -784 688 600",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.62-184q-24.32 0-40.47-16.15T136-240.62v-382.76q0-24.32 16.15-40.47T192.62-680H376v-47.6q0-24.4 16.18-40.4 16.17-16 40.52-16h94.95Q552-784 568-767.85t16 40.46V-680h183.38q24.32 0 40.47 16.15T824-623.38v382.76q0 24.32-16.15 40.47T767.38-184zm0-32h574.76q9.24 0 16.93-7.69t7.69-16.93v-382.76q0-9.24-7.69-16.93T767.38-648H192.62q-9.24 0-16.93 7.69T168-623.38v382.76q0 9.24 7.69 16.93t16.93 7.69M408-680h144v-47.39q0-9.23-7.69-16.92T527.38-752h-94.76q-9.24 0-16.93 7.69T408-727.39zM168-216v-432z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.8a272ce209af27acf7e8f409f2f5c16c.svg";
export { ForwardRef as ReactComponent };